<template lang="pug">
  el-dialog(
    title="添加队员"
    class="el-dialog-custom"
    width="80%"
    :fullscreen="false"
    :visible.sync="visible"
    v-loading="leftloading"
    :append-to-body="true"
    :close-on-click-modal="false"
    @close="closeForm()"
  )
    div(style="margin-bottom: 15px; display: flex;")
      div(style="display: flex; align-items: center;")
        div.professional-point(style="margin-left: 60px;")
        div.title-flag 现役
      div(style="display: flex; align-items: center;")
        div.teamLeader-point(style="margin-left: 60px;")
        div.title-flag 领队
      div(style="display: flex; align-items: center;")
        div.isSixth-point(style="margin-left: 60px;")
        div.title-flag 第六人
    el-row(v-if="visible")
      el-col(:span="12")
        el-card(shadow="never")
          div(slot="header")
            el-row
              el-col(:span="22")
                el-input(v-model="memberName" clearable style="width: 80%;" placeholder="请输入姓名/级别/手机号码")
              el-col(:span="2")
                el-button(@click="sizeChangeHandle" style="float: right;" icon="el-icon-search") 查询
          div
            el-table(
              ref="leftData"
              row-key="id"
              :data="leftData"
              border
              v-el-table-infinite-scroll="currentChangeHandleLeftMember"
              @selection-change="checkLeftMemberAll"
              max-height="300"
            )
              el-table-column(prop="name" label="姓名" align="center")
                template(slot-scope="scope")
                  div(style="display: flex; align-items: center; justify-content: center;")
                    div.professional-point(v-if="scope.row.professional === '0'")
                    div {{ scope.row.name }}
              el-table-column(prop="gender" label="性别" align="center")
                template(slot-scope="scope")
                  font(v-if="scope.row.gender === 0") 男
                  font(v-if="scope.row.gender === 1") 女
              el-table-column(prop="level" label="级别" align="center")
              el-table-column(prop="mobile" label="手机号码" align="center")
              el-table-column(type="selection" align="center" :reserve-selection="true")
      el-col(:span="12")
        el-card(shadow="never")
          div(slot="header")
            font.font_label 已选择的人员
          div
            el-table(:data="rightData" border max-height="317")
              el-table-column(prop="name" label="姓名" align="center")
                template(slot-scope="scope")
                  div(style="display: flex; align-items: center; justify-content: center;")
                    div.teamLeader-point(v-if="scope.row.teamLeader === 1")
                    div.isSixth-point(v-if="scope.row.isSixth === 1")
                    div {{ scope.row.name }}
              el-table-column(prop="gender" label="性别" align="center")
                template(slot-scope="scope")
                  font(v-if="scope.row.gender === 0") 男
                  font(v-if="scope.row.gender === 1") 女
              el-table-column(prop="level" label="级别" align="center")
              el-table-column(prop="mobile" label="手机号码" align="center")
              el-table-column(fixed="right" label="操作" align="center")
                template(slot-scope="scope")
                  i(class="el-icon-error" style="color: #f56c6c; cursor: pointer; font-size: 18px;" @click.prevent="deleteRowLeftMember(scope.$index, rightData)")
                  //- el-button(@click.native.prevent="deleteRowLeftMember(scope.$index, rightData)" type="text" size="small") 移除
    span.dialog-footer(slot="footer")
      el-button(@click="addEnrollClubMember" type="primary") 确 定
      el-button(@click="visible=false") 取 消
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      memberName: '',
      leftData: [], //添加队员左侧列表
      rightData: [], //添加队员右侧列表
      pageIndex: 1,
      pageSize: 100,
      totalPage: 0,
      selectEnrollData: {},
      enrollMember: {},
      rightDataEnroll: [], //当前俱乐部已参赛队员
      ruleForm: {},
      leftloading: false,
      stopChangeRightData: false
    }
  },
  methods: {
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //添加队员
    init (row, ruleForm) {
      this.visible = true
      if (ruleForm) {
        this.ruleForm = ruleForm
      }
      this.memberName = ''
      this.selectEnrollData = row
      this.enrollMember = {}
      this.enrollMember.ctId = this.ruleForm.id
      this.enrollMember.id = this.selectEnrollData.id
      this.leftData = []
      this.rightData = []
      this.rightDataEnroll = []
      this.pageIndex = 1
      this.getLeftData()
    },
    getLeftData () {
      this.leftloading = true
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getClubMbListByCbId`),
        method: 'GET',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'rows': this.pageSize,
          'cbId': this.selectEnrollData.participantInfoId,
          'name': this.memberName
        })
      }).then(data => {
        if (data && data.code === 0) {
          if (this.pageIndex === 1) {
            this.leftData = data.page.rows
          } else {
            this.leftData = this.leftData.concat(data.page.rows)
          }
          this.totalPage = data.page.total
          //查询俱乐部已报名队员
          this.$http({
            url: this.$http.adornUrl(`/mbMember/getEnrollClubMemberList`),
            method: 'GET',
            params: this.$http.adornParams({ 'enrollId': this.selectEnrollData.id })
          }).then(data => {
            this.leftloading = false
            if (data && data.code === 0) {
              if (data.list && data.list.length > 0) {
                let arr = data.list
                this.rightData = arr
                // 对 rightData 重新排序
                this.rightData.sort((a, b) => {
                  // teamLeader===1 的排最前
                  if (a.teamLeader === 1) return -1
                  if (b.teamLeader === 1) return 1
                  // isSixth===1 的排第二
                  if (a.isSixth === 1) return -1
                  if (b.isSixth === 1) return 1
                  // 其他保持原顺序
                  return 0
                })
                this.rightDataEnroll = arr
                this.stopChangeRightData = true
                arr.forEach(e => {
                  this.leftData.forEach(b => {
                    if (e.id === b.id) {
                      // this.rightData.push(b)
                      // 这个方法会触发表格的勾选事件，这里会把左侧表格已经勾选的人员全部循环一边，导致rightData又重新被覆盖了一次
                      this.$refs.leftData.toggleRowSelection(b, true)
                    }
                  })
                })
                this.stopChangeRightData = false
              }
            }
          })
        } else {
          this.leftData = []
          this.totalPage = 0
        }
      })
    },
    //选中添加队员左侧列表
    checkLeftMemberAll (val) {
      // 这里会把左侧勾选中的列表直接覆盖给右侧，而右侧的数据中部分字段是左侧没有的，所以不能直接赋值
      // stopChangeRightData字段是在初次加载表格数据的时候，让左侧表格的勾选操作不会触发这个函数，这样可以减掉多余的逻辑运算
      if (this.stopChangeRightData) return
      const arr = val.map(item => {
        const cell = this.rightData.find(one => one.id === item.id)
        return {
          ...item,
          teamLeader: cell ? cell.teamLeader : 0,
          isSixth: cell ? cell.isSixth : 0
        }
      })
      this.rightData = arr
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = 100
      this.pageIndex = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandleLeftMember (val) {
      let flag = true
      if (this.pageIndex) {
        if (this.pageIndex < Math.ceil(this.totalPage / this.pageSize)) {
          this.pageIndex++
        } else {
          flag = false
        }
      } else {
        this.pageIndex = 1
      }
      if (flag) {
        this.getLeftData()
      }
    },
    deleteRowLeftMember (index, rows) {
      this.$refs.leftData.toggleRowSelection(rows[index], false)
      rows.splice(index, 1)
    },
    //添加俱乐部参赛会员
    addEnrollClubMember () {
      if (this.rightData.length === 0) {
        this.$message.error('请选择要添加的人员!')
      } else if (this.rightData.length > 0) {
        //新添加的队员
        let newList = []
        this.rightData.forEach(e => {
          //标记新添加的
          let newFlag = true
          this.rightDataEnroll.forEach(b => {
            if (e.id === b.id) {
              newFlag = false
            }
          })
          if (newFlag) {
            newList.push(e)
          }
        })
        //此次删除的队员
        let deleteList = []
        this.rightDataEnroll.forEach(e => {
          //标记新添加的
          let deleteFlag = true
          this.rightData.forEach(b => {
            if (e.id === b.id) {
              deleteFlag = false
            }
          })
          if (deleteFlag) {
            deleteList.push(e)
          }
        })
        if (newList.length === 0 && deleteList.length === 0) {
          this.$message.error('没有要添加或删除的人员!')
          return
        }
        this.enrollMember.ctId = this.ruleForm.id
        this.enrollMember.mbMemberList = this.rightData
        let mbIds = []
        newList.forEach(e => {
          mbIds.push(e.id)
        })
        let totalMbIds = []
        this.rightData.forEach(e => {
          totalMbIds.push(e.id)
        })
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/checkMemberByMbIds`),
          method: 'GET',
          params: this.$http.adornParams({
            'ctId': this.ruleForm.id,
            'enrollId': this.enrollMember.id,
            'totalMbIds': totalMbIds.join(','),
            'mbIds': mbIds.join(',')
          })
        }).then(data => {
          if (data && data.code === 0) {
            if (!data.state) {
              this.$message.error(data.info)
            } else {
              this.openFullScreen()
              this.$http({
                url: this.$http.adornUrl(`/elEnroll/saveEnrollClubMember`),
                method: 'post',
                data: this.enrollMember
              }).then(data => {
                if (data && data.code === 0) {
                  if (!data.state) {
                    this.$message.error(data.info)
                  } else {
                    this.$message.success('操作成功!')
                    this.visible = false
                    this.rightData = []
                  }
                } else {
                  this.$message.success('操作失败!')
                }
                this.loading.close()
              })
            }
          }
        })
      }
    },
    closeForm () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog-custom /deep/ .el-dialog__body {
  padding-top: 15px;
}

.title-flag {
  font-size: 18px;
  color: #909399;
}

.professional-point, .teamLeader-point, .isSixth-point {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.professional-point {
  background-color: green;
}

.teamLeader-point {
  background-color: orange;
}

.isSixth-point {
  background-color: red;
}
</style>
